import { Eye, Clock } from "lucide-react";

const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—";

const STATUS_STYLES = {
  Brouillon: "text-slate-500",
  "Envoyé": "text-blue-600",
  "Consulté": "text-amber-600",
  "Signé": "text-emerald-600",
  "Refusé": "text-red-600",
  "Expiré": "text-slate-400",
};

// Displays teaser-email open tracking for a list of NDAs (used in investor + opportunity views).
export default function ConsultationList({ ndas, emptyText = "Aucun teaser envoyé pour le moment." }) {
  if (!ndas || ndas.length === 0) {
    return <p className="text-sm text-slate-400" data-testid="consultation-empty">{emptyText}</p>;
  }
  return (
    <div className="space-y-2" data-testid="consultation-list">
      {ndas.map((n) => (
        <div key={n.id} className="rounded-xl border border-slate-200 bg-white p-3" data-testid={`consultation-${n.id}`}>
          <div className="flex items-center justify-between">
            <p className="text-sm font-medium text-[#0F172A]">
              {n.first_name} {n.last_name}
              {n.company ? <span className="text-slate-400"> · {n.company}</span> : null}
            </p>
            <span className={`text-xs font-semibold ${STATUS_STYLES[n.status] || "text-slate-500"}`}>{n.status}</span>
          </div>
          {n.opportunity_title && <p className="text-xs text-slate-400">{n.opportunity_title}</p>}
          {n.open_count > 0 ? (
            <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-500">
              <span className="flex items-center gap-1 text-[#C6A87C]">
                <Eye className="h-3.5 w-3.5" /> {n.open_count} ouverture{n.open_count > 1 ? "s" : ""}
              </span>
              <span className="flex items-center gap-1">
                <Clock className="h-3.5 w-3.5" /> 1ère : {fmtDateTime(n.first_opened_at)}
              </span>
              <span>Dernière : {fmtDateTime(n.last_opened_at)}</span>
            </div>
          ) : (
            <p className="mt-1.5 text-xs text-slate-400">Pas encore consulté.</p>
          )}
        </div>
      ))}
    </div>
  );
}
